module.exports = __webpack_public_path__ + "img/small-corporate-customer-agreement.ac933e55.svg";